import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/Admin.scss";
import Images from "../../Assets/Images";
import TenantCreateUsers from "../Tenant/TenantCreateUsers";
import ImpactsList from "../Tenant/ImpactsList";
import RiskType from "../Tenant/RiskType";
import UserRole from "../Tenant/UserRole";
import UserAccess from "../Tenant/UserAccess";
import WorkStreamType from "../Tenant/WorkStreamType";
import UserControl from "../Tenant/UserControl";
import CustomField from "../Tenant/CustomField";
import ProbabilityRange from "../Tenant/ProbabilityRange";
import ActionType from "../Tenant/ActionType";
import CurrencyConfiguration from "../Tenant/CurrencyConfiguration";
import ImpactTemplate from "../Tenant/Component/ImpactTemplate";
import HeatmapConfiguration from "../Tenant/HeatmapConfiguration";
import ListAltIcon from '@mui/icons-material/ListAlt';
import DataUpload from "../Tenant/DataUpload";

class Admin extends Component {
  constructor(props) {
    super(props);

    this.openSidebar = this.openSidebar.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      activeSideMenu:secureLocalStorage.getItem('role')=='Project Admin'?"UserControl": "impact",
      openSiderBar: false,
    };
  }
  openSidebar(val) {
    if (!this.state.openSiderBar) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({ ...this.state, openSiderBar: !val });
  }
  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.openSidebar(this.state.openSiderBar);
  }

  openQuadrantReport = async (data) => {
    await this.getRiskDataByViewId(data);
    this.setState({
      showQuadrantReport: true,
      quadrantViewData: data,
    });

    this.refs.child.refreshData();
  };
  

  componentDidMount() {
    this.isAuthorizeUse();
  }

  isAuthorizeUse = () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if(this.props.match.params.id){
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`
        });
      }else{
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      if (this.props.location.adminActiveMenu) {
        this.setState({
          activeSideMenu: this.props.location.adminActiveMenu,
        });
      }
    }
  };

  
  updateView = (activeMenu) => {
    this.setState({ activeSideMenu: activeMenu });
  };
  render() {
    // let isPrime=secureLocalStorage.getItem("isPrime")=="true"?true:false;

    return (
      <div className="d-flex adminContainer noPadd">
        <div
          ref={(node) => {
            this.node = node;
          }}
          className={
            this.state.openSiderBar === true
              ? "adminSidbar show"
              : "adminSidbar"
          }
        >
          {secureLocalStorage.getItem("role") == "Project Admin" ? (
            <ul>
              <li>
                <a
                  className={
                    this.state.activeSideMenu == "UserControl" ? "active" : ""
                  }
                  onClick={() => this.updateView("UserControl")}
                >
                  <span>
                    <img src={Images.WORKSTREAMTYPE} width="14" alt="Icon" />
                  </span>{" "}
                  Manage User Access
                </a>
              </li>
              <li>
                <a
                  className={
                    this.state.activeSideMenu == "DataUpload"
                      ? "active"
                      : ""
                  }
                  onClick={() => this.updateView("DataUpload")}
                > 
                  <span>
                       <ListAltIcon style={{width:'19px',margin:'-3px'}}/>
                          </span>
                          Data Upload               
                    </a>
              </li>
            </ul>
          ) : (
            <ul>
              <li>
                <a
                  className={
                    this.state.activeSideMenu == "impact" ? "active" : ""
                  }
                  onClick={() => this.updateView("impact")}
                >
                  <span>
                    <img src={Images.VIEWLIST} width="14" alt="Icon" />
                  </span>{" "}
                  Impact
                </a>
              </li>

              <li>
                <a
                  className={
                    this.state.activeSideMenu == "user" ? "active" : ""
                  }
                  onClick={() => this.updateView("user")}
                >
                  <span>
                    <img src={Images.USER} width="14" alt="Icon" />
                  </span>{" "}
                  Users
                </a>
              </li>

              <li>
                <a
                  className={
                    this.state.activeSideMenu == "actionType" ? "active" : ""
                  }
                  onClick={() => this.updateView("actionType")}
                >
                  <span>
                    <img src={Images.STAIRS} width="13" alt="Icon" />
                  </span>{" "}
                  Action Type
                </a>
              </li>

              <li>
                <a
                  className={
                    this.state.activeSideMenu == "risktype" ? "active" : ""
                  }
                  onClick={() => this.updateView("risktype")}
                >
                  <span>
                    <img src={Images.RISKTYPE} width="14" alt="Icon" />
                  </span>{" "}
                  Risk Type
                </a>
              </li>
              <li>
                <a
                  className={
                    this.state.activeSideMenu == "workstreamtype"
                      ? "active"
                      : ""
                  }
                  onClick={() => this.updateView("workstreamtype")}
                >
                  <span>
                    <img src={Images.WORKSTREAMTYPE} width="14" alt="Icon" />
                  </span>{" "}
                  Workstream Type
                </a>
              </li>

              <li>
                <a
                  className={
                    this.state.activeSideMenu == "CustomField" ? "active" : ""
                  }
                  onClick={() => this.updateView("CustomField")}
                >
                  <span>
                    <img src={Images.HISTORY} width="14" alt="Icon" />
                  </span>{" "}
                  Custom Field
                </a>
              </li>

              <li>
                <a
                  className={
                    this.state.activeSideMenu == "probabilityRange"
                      ? "active"
                      : ""
                  }
                  onClick={() => this.updateView("probabilityRange")}
                >
                  <span>
                    <img src={Images.HEATMAP} width="14" alt="Icon" />
                  </span>{" "}
                  Probability Range
                </a>
              </li>
              {/* {isPrime ? (
                <li>
                  <a
                    className={
                      this.state.activeSideMenu == "prime" ? "active" : ""
                    }
                    onClick={() => this.updateView("prime")}
                  >
                    <span>
                      <img src={Images.TYPES} width="14" alt="Icon" />
                    </span>{" "}
                    Prime Impact
                  </a>
                </li>
              ) : (
                ""
              )} */}
              <li>
                <a
                  className={
                    this.state.activeSideMenu == "CurrencyConfiguration"
                      ? "active"
                      : ""
                  }
                  onClick={() => this.updateView("CurrencyConfiguration")}
                >  <span>
                  <img
                      src={Images.VIEWDATA} width="12" alt="Icon"/>
                    </span>
                  Currency Configuration
                </a>
              </li>

              <li>
                <a
                  className={
                    this.state.activeSideMenu == "HeatmapConfiguration"
                      ? "active"
                      : ""
                  }
                  onClick={() => this.updateView("HeatmapConfiguration")}
                > 
                  <span>
                       <img  src={Images.TEMPLATE}    width="14"   alt="Mitigations" />
                          </span>
                    Heatmap Configuration                
                    </a>
              </li>
              <li>
                <a
                  className={
                    this.state.activeSideMenu == "DataUpload"
                      ? "active"
                      : ""
                  }
                  onClick={() => this.updateView("DataUpload")}
                > 
                  <span>
                       <ListAltIcon style={{width:'19px',margin:'-3px'}}/>
                          </span>
                          Data Upload               
                    </a>
              </li>
            </ul>
          )}
        </div>
        <div className="adminWrapper">
          <a
            class="sidebarNavIcon"
            onClick={() => this.openSidebar(this.state.openSiderBar)}
          >
            <img src={Images.SETTINGS} width="18" alt="Stream" />
          </a>
          {/* <p>{this.state.activeSideMenu}</p> */}
          {this.state.activeSideMenu == "impact" ? (
            <ImpactsList {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "user" ? (
            <TenantCreateUsers {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "actionType" ? (
            <ActionType {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "risktype" ? (
            <RiskType {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "userrole" ? (
            <UserRole {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "useraccess" ? (
            <UserAccess {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "UserControl" ? (
            <UserControl {...this.props} />
          ) : (
            ""
          )}

          {this.state.activeSideMenu == "workstreamtype" ? (
            <WorkStreamType {...this.props} />
          ) : (
            ""
          )}

          {this.state.activeSideMenu == "CustomField" ? (
            <CustomField {...this.props} />
          ) : (
            ""
          )}

          {this.state.activeSideMenu == "probabilityRange" ? (
            <ProbabilityRange {...this.props} />
          ) : (
            ""
          )}
          {/* {this.state.activeSideMenu == "prime" ? (
            <ImpactTemplate {...this.props} />
          ) : (
            ""
          )} */}
           {this.state.activeSideMenu == "CurrencyConfiguration" ? (
            <CurrencyConfiguration {...this.props} />
          ) : (
            ""
          )}
           {this.state.activeSideMenu == "HeatmapConfiguration" ? (
            <HeatmapConfiguration {...this.props} />
          ) : (
            ""
          )}
          {this.state.activeSideMenu == "DataUpload" ? (
            <DataUpload {...this.props} />
          ) : (
            ""
          )}
          
        </div>
      </div>
    );
  }
}
export default Admin;
